import { useEffect, useState } from 'react'

const easeOutQuad = t => t * (2 - t)
const frameDuration = 1000 / 60

const CountUp = ({ delay = 0, end = 0, duration = 1000 }) => {
	const countTo = end
	const [count, setCount] = useState(0)

	useEffect(() => {
		const startAnim = () => {
			let frame = 0
			const totalFrames = Math.round(duration / frameDuration)
			const counter = setInterval(() => {
				frame++
				const progress = easeOutQuad(frame / totalFrames)
				setCount(countTo * progress)
	
				if (frame === totalFrames) {
					clearInterval(counter)
				}
			}, frameDuration)
		}

		setTimeout(startAnim, delay)
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return Math.floor(count)
}

export default CountUp